import moment from 'moment';
import { SuperParticipantsModel } from '../superCompos/super-participants-model';
import { MailRecipientDetailsDto } from 'src/app/shared/interfaces';

export class MailDestinataire extends SuperParticipantsModel {
  public id: number;
  public mailId: number;
  public type?: string; // Type destinataire: DESTINATAIRE or SERVICE
  public transmissionUserId?: number;
  public contactId: number | null;
  public contactIdiAdmin: number | null;
  public contactiAdminId: number | null;
  public libre?: string;
  public principal: boolean;
  public serviceProprietaireId?: number;
  public serviceDestinataireId?: number;
  public isService?: boolean;
  public commentaires?: string;

  // fields for superParticipants
  public nom?: string;
  public prenom?: string;
  public picture?: string;

  // fields for service if type === SERVICE
  public description?: string;
  public email?: string; // used for destinataire service
  public serviceUserName?: string;

  //field for groups if type === GROUPE
  public groupName?: string;
  public groupUserName?: string;

  // datas to display in the destinataire table, inside the tooltips
  public recipientAddress?: string = null;
  public recipientType?: string = null;
  public user? = null;
  public transmisDate;
  public transmisDateOrderUnix;
  public echeance;
  public echeanceDateOrderUnix;
  public action?;
  public answerDisplayedInListView?;
  public reponse?;
  public contactName?: string;

  constructor(data?: MailDestinataire | MailRecipientDetailsDto) {
    super();
    Object.assign(this, data);
    if (this.nom) {
      this.setLastName(this.nom);
    }
    if (this.prenom) {
      this.setFirstName(this.prenom);
    }
    this.setName((this.prenom ? this.prenom : '') + '' + (this.nom ? this.nom : ''));
    this.contactName = this.name;
    this.setServiceName(this.description);
    this.setGroupName(this.description);
    this.transmisDateOrderUnix = this.transmisDate ? moment(this.transmisDate).unix() : '';
    this.echeanceDateOrderUnix = this.echeance ? moment(this.echeance).unix() : '';
  }
  public setAddress(address) {
    this.recipientAddress = address
      ? (address.impression_Adresse ? address.impression_Adresse + ' ' : '') +
        (address.impression_CodePostal ? address.impression_CodePostal + ' ' : '') +
        (address.impression_Localite ? address.impression_Localite : '')
      : '/';
  }
  public setRecipientType(res) {
    this.recipientType = res;
  }

  public setServiceEmail(email: string) {
    return (this.email = email);
  }
}

export interface MailRecipientDeleteDTO {
  destinataires: {
    id: number;
    contactName: string;
  }[];
}
